import { render } from "./InputUpload.vue?vue&type=template&id=472b5ec0"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__